var chunkMapping = {
	"182": [
		27802
	],
	"197": [
		65222,
		95984
	],
	"262": [
		90657
	],
	"676": [
		54317
	],
	"746": [
		10746
	],
	"979": [
		48448
	],
	"1218": [
		91218
	],
	"1305": [
		32228
	],
	"1569": [
		31569
	],
	"1929": [
		51929
	],
	"2031": [
		22031
	],
	"2045": [
		82045
	],
	"2058": [
		9853,
		23146,
		25501,
		32228,
		51649,
		68964,
		83425,
		86994,
		96928
	],
	"2238": [
		82238
	],
	"2856": [
		82856
	],
	"3145": [
		23145
	],
	"3436": [
		53436
	],
	"3439": [
		30801,
		93828
	],
	"3659": [
		12652,
		87216
	],
	"4110": [
		84110
	],
	"4141": [
		4141
	],
	"4323": [
		27802
	],
	"4418": [
		74418
	],
	"4542": [
		54542
	],
	"4843": [
		4843
	],
	"4918": [
		54918
	],
	"5080": [
		68964
	],
	"5312": [
		1661,
		27802,
		90657
	],
	"5324": [
		45324
	],
	"5333": [
		7800,
		53102,
		63870,
		67380
	],
	"5685": [
		90657
	],
	"5850": [
		9194,
		52268
	],
	"6235": [
		57775
	],
	"6828": [
		26828
	],
	"7343": [
		67343
	],
	"7359": [
		37359
	],
	"7361": [
		17361
	],
	"7467": [
		37467
	],
	"7595": [
		48448
	],
	"7820": [
		7820
	],
	"7867": [
		7867
	],
	"8200": [
		28200
	],
	"8439": [
		78439
	],
	"8478": [
		58478
	],
	"8615": [
		7800,
		53102
	],
	"8941": [
		28941
	],
	"9136": [
		39136
	],
	"9329": [
		77820
	],
	"9876": [
		39876
	]
};
var idToExternalAndNameMapping = {
	"1661": [
		"default",
		"./src/helpers/randomIdGenerator",
		89327
	],
	"4141": [
		"default",
		"./src/assets/iconEdit.svg",
		89327
	],
	"4843": [
		"default",
		"./src/hooks/useToggle",
		89327
	],
	"7800": [
		"default",
		"./src/assets/iconCorvinusRaven.svg",
		89327
	],
	"7820": [
		"default",
		"./src/assets/iconEventCalendar.svg",
		89327
	],
	"7867": [
		"default",
		"./src/assets/iconChevronD.svg",
		89327
	],
	"9194": [
		"default",
		"./src/assets/iconDone.svg",
		89327
	],
	"9853": [
		"default",
		"./src/assets/iconMenu.svg",
		89327
	],
	"10746": [
		"default",
		"./src/components/Modal",
		89327
	],
	"12652": [
		"default",
		"./src/assets/iconFavoriteStarFilled.svg",
		89327
	],
	"17361": [
		"default",
		"./src/components/Avatar",
		89327
	],
	"22031": [
		"default",
		"./src/assets/iconStudent.svg",
		89327
	],
	"23145": [
		"default",
		"./src/components/CharacteristicsChart/CharacteristicsChart",
		89327
	],
	"23146": [
		"default",
		"./src/assets/iconCalendar2.svg",
		89327
	],
	"25501": [
		"default",
		"./src/assets/iconCarreerComp.svg",
		89327
	],
	"26828": [
		"default",
		"./src/assets/iconAddToSemester.svg",
		89327
	],
	"27802": [
		"default",
		"./src/assets/iconDrag.svg",
		89327
	],
	"28200": [
		"default",
		"./src/assets/iconInfo.svg",
		89327
	],
	"28941": [
		"default",
		"./src/assets/iconNavigatorPoint.svg",
		89327
	],
	"30801": [
		"default",
		"./src/assets/iconFullScreen.svg",
		89327
	],
	"31569": [
		"default",
		"./src/assets/iconSend.svg",
		89327
	],
	"32228": [
		"default",
		"./src/components/LoaderIcon/LoaderIcon",
		89327
	],
	"37359": [
		"default",
		"./src/components/TextInput",
		89327
	],
	"37467": [
		"default",
		"./src/assets/iconClose.svg",
		89327
	],
	"39136": [
		"default",
		"./src/assets/iconFilter.svg",
		89327
	],
	"39876": [
		"default",
		"./src/assets/characteristicsChartPlaceholder.svg",
		89327
	],
	"45324": [
		"default",
		"./src/components/Pill",
		89327
	],
	"48448": [
		"default",
		"./src/assets/iconDownload.svg",
		89327
	],
	"51649": [
		"default",
		"./src/components/Layout",
		89327
	],
	"51929": [
		"default",
		"./src/components/Checkbox",
		89327
	],
	"52268": [
		"default",
		"./src/assets/iconAdd.svg",
		89327
	],
	"53102": [
		"default",
		"./src/assets/iconTimetable.svg",
		89327
	],
	"53436": [
		"default",
		"./src/components/DropdownSelect",
		89327
	],
	"54317": [
		"default",
		"./src/api/optin/optin.api",
		89327
	],
	"54542": [
		"default",
		"./src/components/Buttons/Button",
		89327
	],
	"54918": [
		"default",
		"./src/assets/iconChevronR.svg",
		89327
	],
	"57775": [
		"default",
		"./src/i18n/i18n-react",
		89327
	],
	"58478": [
		"default",
		"./src/assets/iconDelete.svg",
		89327
	],
	"63870": [
		"default",
		"./src/assets/iconChevronU.svg",
		89327
	],
	"65222": [
		"default",
		"./src/components/FileUploader",
		89327
	],
	"67343": [
		"default",
		"./src/components/Snackbar/Snackbar",
		89327
	],
	"67380": [
		"default",
		"./src/assets/eventEmptyState.svg",
		89327
	],
	"68964": [
		"default",
		"./src/assets/iconAlert.svg",
		89327
	],
	"74418": [
		"default",
		"./src/components/Modal/Modal",
		89327
	],
	"77820": [
		"default",
		"./src/hooks/useLoading",
		89327
	],
	"78439": [
		"default",
		"./src/api/api.client",
		89327
	],
	"82045": [
		"default",
		"./src/assets/iconChevronL.svg",
		89327
	],
	"82238": [
		"default",
		"./src/hooks/useClickOutside",
		89327
	],
	"82856": [
		"default",
		"./src/components/Snackbar",
		89327
	],
	"83425": [
		"default",
		"./src/assets/iconMenuDark.svg",
		89327
	],
	"84110": [
		"default",
		"./src/components/Loader",
		89327
	],
	"86994": [
		"default",
		"./src/assets/iconCalendar.svg",
		89327
	],
	"87216": [
		"default",
		"./src/assets/iconFavoriteStarEmpty.svg",
		89327
	],
	"90657": [
		"default",
		"./src/components/RadioGroup",
		89327
	],
	"91218": [
		"default",
		"./src/types",
		89327
	],
	"93828": [
		"default",
		"./src/assets/iconMinimize.svg",
		89327
	],
	"95984": [
		"default",
		"./src/components/TextArea",
		89327
	],
	"96928": [
		"default",
		"./src/assets/iconQ.svg",
		89327
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}